// src/App.js
//import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Jobs from "./pages/Jobs";
import NewJobDetails from "./NewJobDetails";
//import NewApplyForm from "./NewApplyForm";
import Header from "./Components/Header";

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Jobs />} />
        <Route path="/job/:id" element={<NewJobDetails />} />
       {/* <Route path="/apply/:id" element={<NewApplyForm />} /> */}
      </Routes>
    </Router>
  );
}

export default App;




